import { createAsyncThunk } from "@reduxjs/toolkit";
import { customMediaCampaignService } from "../../services";

const createMessage = createAsyncThunk(
    'customMediaCampaign/createMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await customMediaCampaignService.createMessage(
                payload.companyId,
                payload.campaignId, 
                payload.data,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const updateMessage = createAsyncThunk(
    'customMediaCampaign/updateMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await customMediaCampaignService.updateMessage(
                payload.companyId,
                payload.campaignId, 
                payload.messageId, 
                payload.data,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const deleteMessage = createAsyncThunk(
    'customMediaCampaign/deleteMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await customMediaCampaignService.deleteMessage(
                payload.companyId,
                payload.campaignId, 
                payload.messageId,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getMessage = createAsyncThunk(
    'customMediaCampaign/getMessage',
    async (payload, ThunkAPI) => {
        try{
            const response = await customMediaCampaignService.getMessage(
                payload.companyId,
                payload.campaignId, 
                payload.messageId,
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);

const getCampaignEchos = createAsyncThunk(
    'customMediaCampaign/getCampaignEchos',
    async (payload, ThunkAPI) => {
        try{
            const response = await customMediaCampaignService.getCampaignEchos(
                payload.companyId,
                payload.campaignId, 
            )
            return response.data;
        } catch (error) {
            return ThunkAPI.rejectWithValue(error.message);
        }
    }
);


export {
    createMessage,
    updateMessage,
    deleteMessage,
    getMessage,
    getCampaignEchos,
}